import { useMemo } from 'react';
import { useLocation } from '@tanstack/react-router';

import { resolveRouteId } from '@/utils/resolve-route-id';

/**
 * Hook to get the current route ID based on the pathname
 * Returns the AtlasRouteId that corresponds to the current page
 */
export const useCurrentRoute = (): string | undefined => {
  const pathname = useLocation({
    select: (location) => location.pathname,
  });

  return useMemo(() => resolveRouteId(pathname), [pathname]);
};
